// Single source of truth for the code/monospace font used across the app
// (API keys, code samples, Monaco editors, jq builder, `font-mono` Tailwind class).
// The font files ship with the app: see the @font-face rules in index.css.
export const MONO_FONT_NAME = 'Roboto Mono';
export const MONO_FONT_FAMILY = `'${MONO_FONT_NAME}', ui-monospace, Menlo, Monaco, Consolas, monospace`;

// Exposes the font as the --font-mono CSS variable (consumed by
// tailwind.config.js `fontFamily.mono` and index.css).
// Monaco editors can't resolve CSS variables (they measure fonts via canvas),
// so they import MONO_FONT_FAMILY directly.
export const applyMonoFont = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty('--font-mono', MONO_FONT_FAMILY);
};
